import draggable from 'vuedraggable'
import DatePicker from 'vue2-datepicker'
import {SemipolarSpinner} from 'epic-spinners'

export const mixin = {
  components: {
    draggable, DatePicker, SemipolarSpinner
  },
  data: function () {
    return {
      multiSelect: {
        leaveUsers: null,
        assignedUser: null,
        costCompanies: null,
        sponsorCompanies: null,
        checkIn: [],
        checkOut: [],
        breakStart: [],
        breakEnd: [],
        checkIn2: [],
        checkOut2: [],
        checkIn3: [],
        checkOut3: [],
        checkIn4: [],
        checkOut4: [],
        punchDate: null,
        employeeIDCreate: null,
        leaveTypeCreate: null,
        leaveTypeUpdate: null,
      },
      dateSelect: {
        leaveDateFrom: null,
        leaveDateTo: null,
      },
      pastDateRangeTemplates: [
        {
          text: 'Today',
          start: new Date(),
          end: new Date()
        },
        {
          text: 'Yesterday',
          start: this.$moment().subtract(1, 'd'),
          end: this.$moment().subtract(1, 'd')
        },
        {
          text: 'Last 7 Days',
          start: this.$moment().subtract(7, 'd'),
          end: new Date()
        },
        {
          text: 'This Month',
          start: this.$moment().startOf('month'),
          end: new Date()
        },
        {
          text: 'Last 90 Days',
          start: this.$moment().subtract(3, 'months'),
          end: new Date()
        },

      ],
      statuses: [
        {id: 0, name: 'Inactive'},
        {id: 1, name: 'Active'},
      ],
    }
  },
  created: function () {
    console.log('Mixin: Mixin Used')
  },
  methods: {
    iScreen(sizes)
    {
      let result = false;
      for (let s of sizes) {
        if(s === this.$mq){result = true;}
      }
      return result;
    },

    iShowCollapse(menu){
      for(let items of menu)
      {
        if(items.children){
          for(let item of items.children)
          {
            if(item.link === this.$route.path || item.link === this.$route.path+this.$route.hash){items.toggle = true;}
          }
        }
      }
    },

    iFormatDate(date){
      return this.$moment(date).format('Do MMM YY')
    },

    iTimeLeft(dueDate, completionDate){
      let icon = 'check';
      let color = 'green';
      let text = 'Done';

      if(!completionDate || completionDate === null || completionDate === ''){
        let a = this.$moment(dueDate);
        let b = this.$moment();
        let difference = a.diff(b, 'hours');

        if(difference === 0) {
          icon = 'calendar';
          color = '#c27b00';
          text = 'Few Minutes';
        }
        if(difference > 0) {
          icon = 'hourglass-half';
          color = '#c2b700';
          text = difference + ' hours left';
        }
        if(difference === 1) {
          text = difference + ' hour left';
        }
        if(difference > 12) {
          icon = 'hourglass-start';
          color = '#5d9e01';
          text = difference + ' hours left';
        }
        if(difference > 24) {
          icon = 'hourglass-start';
          color = '#5d9e01';
          text = (difference/24).toFixed(0) + ' day left';
        }
        if(difference > 48) {
          icon = 'hourglass-start';
          color = '#5d9e01';
          text = (difference/24).toFixed(0) + ' days left';
        }
        if(difference < 0) {
          icon = 'hourglass-end';
          color = '#b44940';
          text = -difference + ' hours late';
        }
        if(difference < -12) {
          icon = 'exclamation-circle';
          color = '#ef340c';
          text = -difference + ' hours late';
        }
        if(difference < -24) {
          icon = 'exclamation-circle';
          color = '#ef340c';
          text = (-difference/24).toFixed(0) + ' day late';
        }
        if(difference === -24) {
          text = (-difference/24).toFixed(0) + ' day late';
        }
        if(difference < -47) {
          text = (-difference/24).toFixed(0) + ' days late';
        }
      }
      return {
        'icon': icon,
        'color': color,
        'text': text
      }
    },

    iUpdatedAgo(date){
      let past = this.$moment(date);
      let now = this.$moment();
      return past.from(now);
    },

    iGetInitials (name){
      let initials = name.match(/\b\w/g) || [];
      initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
      return initials.substring(0,3);
    },

    iValidateEmail(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    iCleanHtml(html){
      let temp = document.createElement("div");
      temp.innerHTML = html;
      return temp.textContent || temp.innerText || "";
    },

    status(statusID){
      if(statusID == 1){return "<span class='badge badge-success'>Active</span>";}
      if(statusID == 0){return "<span class='badge badge-danger'>Inactive</span>";}
    },
    // Helper functions to select the objects by searching through ID
    findCompany(id){for (let s of this.companies) {if(s.id == id){return s}}},
    findSponsorCompany(id){for (let s of this.sponsorCompanies) {if(s.id == id){return s}}},
    findBranch(id){for (let s of this.branches) {if(s.id == id){return s}}},
    findDepartment(id){for (let s of this.departments) {if(s.id == id){return s}}},
    findNationality(id){for (let s of this.nationalities) {if(s.id == id){return s}}},
    findDesignation(id){for (let s of this.designations) {if(s.id == id){return s}}},
    findReligion(id){for (let s of this.religions) {if(s.id == id){return s}}},
    findShiftPlan(id){for (let s of this.$store.getters['shifts/getShiftPlans']) {if(s.id == id){return s}}},
    findUser(id){for (let s of this.users) {if(s.id == id){return s}}},
    findShiftDayPolicy(id){for (let s of this.shiftDayPolicies) {if(s.id == id){return s}}},
    findLeaveType(id){for (let s of this.$store.getters['leaves/getLeaveTypes']) {if(s.id == id){return s}}},
    findHoliday(date){for (let s of this.$store.getters['holidays/getHolidays']) {if(s.date == date){return s}}},
    findStatus(id){ if(this.statuses){for (let s of this.statuses) {if(s.id == id){return s}}}},
    findShiftCategories(id){for (let s of this.$store.getters['shifts/getShiftCategories']) {if(s.id == id){return s}}},
    //
    // findShiftCategories(id){
    //   for (let w of this.$store.getters['shifts/getShiftCategories']) {if(w.id == id){return w.name} else {return {id: null, name: null,}}}
    //   },
    findCutOffDate(){for (let s of this.$store.getters['environment/getSettingsHR']) {if(s.name == 'cutOffDate'){return s.value}}},
    findVisibilityStart(){for (let s of this.$store.getters['environment/getSettingsHR']) {if(s.name == 'visibilityStart'){return s.value}}},
    findVisibilityEnd(){for (let s of this.$store.getters['environment/getSettingsHR']) {if(s.name == 'visibilityEnd'){return s.value}}},
    findCycles(){for (let s of this.$store.getters['environment/getSettingsHR']) {if(s.name === 'cycles'){return s}}},

    permissionCheck(moduleName, actionName){
      for (let s of this.$store.getters['security/getUserPermissions'])
      {if(s.moduleName === moduleName && s.actionName === actionName){return true;}}
      return false;
    },

  },

  computed: {
    adminCheck() {
      let needle = false;
      if(this.$store.getters['user/getProfile'].admin === '1'){needle = true;}
      return needle;
    },

  }
}


// WEBPACK FOOTER //
// ./src/mixins/mixins.js